<div class="proposals">
  <!--
  <h3> Rendez vous ({{proposals == null ? 0 : proposals!.length}})</h3>
  <button *ngIf="(appointments == undefined || appointments.length === 0 )"
    class="cta-button"  mat-button (click)="openAppointmentDialog('', undefined);$event.stopPropagation()">
    Nouvelle<mat-icon>add</mat-icon>
  </button> -->

  @if (enableNew) {
    <button mat-button class="cta-button-buy" (click)="openProposalDialog(0);$event.stopPropagation()">
      Nouvelle<mat-icon>add</mat-icon>
    </button>
  }

  @if (proposals == undefined || proposals.length === 0) {
    <h6>
      Aucune proposition en cours
    </h6>
  }

  @if (!(proposals == undefined || proposals.length === 0 )) {
    <div class="proposal-list">
      @for (proposal of proposals; track proposal; let i = $index) {
        <div class="proposal">
          <div class="summary">
            <!-- <b>[{{ (conversation.participants[0] === null)? 'EXT' : conversation.participants[0] }}]</b> -->
            @if (objectSource===ObjectSource.DEALER) {
              <h4> {{proposal.carMake}} {{proposal.carModel}} {{proposal.carVersion}} </h4>
            }
            <h5 class="summary-details"><mat-icon>forum</mat-icon> N° {{proposal.id}} - {{proposal.type}} </h5>
            <h6 class="summary-details"><mat-icon>person</mat-icon> Client: <b>{{proposal.customerName}}</b></h6>
            <h6 class="summary-details"><mat-icon>person</mat-icon> Vendeur: <b>{{proposal.providerName}}</b></h6>
          </div>
          <div class="content">
            <h4> {{moneyFormat(""+proposal.proposedPrice.amount)}} {{proposal.proposedPrice.currency}}</h4>
            <h5 class="status">{{proposal.status}}</h5>
            <h6> Date demandée: {{dateFormat(proposal.appointmentDate)}}</h6>
            <h6> Commentaire: {{proposal.comment}}</h6>
            @if (proposal.modification !== null) {
              <span>
                <h5> Modif:</h5>
                <h6 > {{proposal.modification!.proposedPrice.amount}} {{proposal.modification!.proposedPrice.currency}}
                  / {{dateFormat(proposal.modification!.appointmentDate)}} / {{proposal.modification!.comment}} /
                {{proposal.modification!.status}}</h6>
              </span>
            }
            @if (proposal.status === ProposalStatus.COMPLETED) {
              <span>
                <h5> Vente:</h5>
                <h6> {{proposal.completedPrice.amount}} {{proposal.completedPrice.currency}}
                / {{dateFormat(proposal.completedDate)}} / {{proposal.completedNotes}} </h6>
              </span>
            }
            <!--
            <h6> Date création: {{dateFormat(proposal.created)}}</h6>
            <h6> Dernière mise a jour: {{dateFormat(proposal.lastUpdated)}}</h6>  -->
            <div class="action-buttons">
              @for (actionItem of proposalActionItems; track actionItem; let j = $index) {
                <div>
                  @if (proposal.actions?.includes(actionItem.action)) {
                    <button
                      class="simple-button"  mat-button (click)="executeProposalAction(proposal, actionItem.action);$event.stopPropagation()">
                      {{ actionItem.title }} <mat-icon> {{ actionItem.icon }}</mat-icon>
                    </button>
                  }
                </div>
              }
            </div>
            <!--
            <div class="action-buttons">
              <button *ngIf="(proposal.status !== ProposalStatus.CANCELLED)"
                class="simple-button"  mat-button (click)="updateProposalStatus(proposal.id, ProposalStatus.CANCELLED);$event.stopPropagation()">
                Annuler <mat-icon>cancel</mat-icon>
              </button>
              <button *ngIf="(proposal.status === ProposalStatus.SENT)"
                class="simple-button"  mat-button (click)="openProposalDialog(proposal.id, false);$event.stopPropagation()">
                Editer <mat-icon>edit</mat-icon>
              </button>
              <button *ngIf="(proposal.status === ProposalStatus.ACCEPTED)"
                class="simple-button"  mat-button (click)="openProposalDialog(proposal.id, true);$event.stopPropagation()">
                Changer date <mat-icon>calendar</mat-icon>
              </button>
              <button *ngIf="(proposal.status === ProposalStatus.SENT)"
                class="cta-button-buy"  mat-button (click)="updateProposalStatus(proposal.id, ProposalStatus.ACCEPTED);$event.stopPropagation()">
                Accepter <mat-icon>accept</mat-icon>
              </button>
            </div>  -->
          </div>
        </div>
      }
    </div>
  }
</div>